import React from 'react';
import PropTypes from 'prop-types';
import { get, orderBy } from 'lodash';
import withData from '@bd/bdcore-data';

import { components } from '../../components/PageLoader/Sections';

function SectionsGuide({ settings, page }) {
  const availableSections = orderBy(get(settings, 'sections2020', []), 'meta.name');
  const sections = availableSections.map(section => ({
    Component: components[get(section, 'meta.name')],
    name: get(section, 'meta.name'),
    data: get(section, get(section, 'meta.fields[0].key')),
  })).filter(section => section.Component);

  return (
    <div>
      {
        sections.map(({ Component, data, name }) => (
          <div key={name} className="my-5 py-5" style={{ borderBottom: '1px solid #ccc' }}>
            <div className="row py-5">
              <div className="col">
                <h2 className="text-center">{name}</h2>
              </div>
            </div>
            <Component content={data} currentPage={page} />
          </div>
        ))
      }
    </div>
  );
}

SectionsGuide.propTypes = {
  settings: PropTypes.object.isRequired,
  page: PropTypes.object.isRequired,
};

export default withData({ settings: true })(SectionsGuide);



// WEBPACK FOOTER //
// ./src/pages/StyleGuide/SectionsGuide.js